var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.editing,
            expression: "!editing",
          },
        ],
        staticClass: "col-value",
        on: { click: _vm.startEditing },
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.newValue ? _vm.newValue : _vm.value) +
            "\n    "
        ),
      ]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.editing,
          expression: "editing",
        },
        {
          name: "model",
          rawName: "v-model",
          value: _vm.newValue,
          expression: "newValue",
        },
      ],
      ref: "input",
      staticClass: "form-control",
      attrs: { placeholder: "0" },
      domProps: { value: _vm.newValue },
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.saveEditing.apply(null, arguments)
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.cancelEditing.apply(null, arguments)
        },
        input: function ($event) {
          if ($event.target.composing) return
          _vm.newValue = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }